<div class="selecao-fundo" role="presentation" (click)="fecharPeloFundo($event)">
  <section class="selecao-painel" role="dialog" aria-modal="true" aria-labelledby="selecao-template-titulo"
           appArrastarFecharSheet [painelProprio]="true" [arrastarHabilitado]="!enviando()" (arrastouParaFechar)="fechar.emit()">
    <span class="selecao-alca" aria-hidden="true"></span>

    <header class="selecao-cabecalho">
      <h2 id="selecao-template-titulo" class="selecao-titulo">Templates aprovados</h2>
      <button type="button" class="selecao-btn-fechar" aria-label="Fechar" [disabled]="enviando()" (click)="fechar.emit()">
        <img src="./assets/icones/redesign/inputs/container-cancel.svg" alt="" />
      </button>
    </header>

    <div class="selecao-corpo">
      <div class="selecao-lista-coluna">
        <label class="selecao-busca">
          <img src="./assets/icones/redesign/inputs/icon-search-input.svg" alt="" class="selecao-busca-icone" />
          <input type="text" class="selecao-busca-input" placeholder="Buscar template..." autocomplete="off"
                [value]="busca()" (input)="aoDigitarBusca($any($event.target).value)" />
        </label>

        <div class="selecao-lista" #listaTemplates (scroll)="aoRolarLista()">
          @if (carregandoLista()) {
            @for (linha of linhasSkeleton; track linha) {
              <div class="selecao-item selecao-item-skeleton">
                <div class="selecao-item-topo">
                  <div class="skeleton selecao-skeleton-titulo" [style.width.%]="linha % 2 === 0 ? 38 : 52"></div>
                  <div class="skeleton selecao-skeleton-badge"></div>
                </div>
                <div class="skeleton selecao-skeleton-linha" [style.width.%]="linha % 2 === 0 ? 70 : 58"></div>
              </div>
            }
          } @else if (erroLista()) {
            <div class="selecao-vazio">
              <span>Não foi possível carregar os templates.</span>
              <button type="button" class="selecao-btn-texto" (click)="tentarNovamenteLista()">Tentar novamente</button>
            </div>
          } @else {
            @for (template of templates(); track template.id) {
              <div class="selecao-item" [class.selecao-item-ativo]="selecionadoId() === template.id">
                <button type="button" class="selecao-item-botao"
                        [attr.aria-expanded]="selecionadoId() === template.id"
                        (click)="selecionar(template)"
                        (pointerenter)="preCarregar(template)"
                        (pointerleave)="cancelarPreCarregamento()">
                  <span class="selecao-item-topo">
                    <span class="selecao-item-nome">{{ template.nome }}</span>
                    <span class="selecao-badge-aprovado">Aprovado</span>
                  </span>
                  @if (template.previa) {
                    <span class="selecao-item-previa">{{ template.previa }}</span>
                  }
                </button>
                <button type="button" class="selecao-item-botao selecao-item-botao-accordion"
                        [attr.aria-expanded]="selecionadoId() === template.id"
                        (click)="alternar(template)">
                  <span class="selecao-item-topo">
                    <span class="selecao-item-nome">{{ template.nome }}</span>
                    <span class="selecao-badge-aprovado">Aprovado</span>
                  </span>
                  @if (template.previa && selecionadoId() !== template.id) {
                    <span class="selecao-item-previa">{{ template.previa }}</span>
                  }
                </button>

                @if (selecionadoId() === template.id) {
                  <div class="selecao-item-expandido">
                    <div class="selecao-previa-area selecao-previa-area-card">
                      <ng-container [ngTemplateOutlet]="previa"></ng-container>
                    </div>
                    <ng-container [ngTemplateOutlet]="camposVariaveis"></ng-container>
                    <ng-container [ngTemplateOutlet]="botaoEnviar"></ng-container>
                  </div>
                }
              </div>
            } @empty {
              <div class="selecao-vazio">
                @if (busca().trim()) {
                  <span>Nenhum template encontrado para "{{ busca().trim() }}".</span>
                } @else {
                  <span>Nenhum template aprovado disponível.</span>
                }
              </div>
            }
            @if (carregandoMais()) {
              @for (linha of [1, 2]; track linha) {
                <div class="selecao-item selecao-item-skeleton">
                  <div class="selecao-item-topo">
                    <div class="skeleton selecao-skeleton-titulo" [style.width.%]="linha % 2 === 0 ? 38 : 52"></div>
                    <div class="skeleton selecao-skeleton-badge"></div>
                  </div>
                  <div class="skeleton selecao-skeleton-linha" [style.width.%]="linha % 2 === 0 ? 70 : 58"></div>
                </div>
              }
            }
          }
        </div>
      </div>

      <div class="selecao-detalhe">
        @if (selecionado(); as template) {
          <div class="selecao-detalhe-conteudo">
            <div class="selecao-detalhe-topo">
              <span class="selecao-detalhe-nome">{{ template.nome }}</span>
              @if (template.categoria) {
                <span class="selecao-badge-categoria">{{ template.categoria }}</span>
              }
            </div>
            <div class="selecao-detalhe-rotulo">
              <span>Prévia da mensagem</span>
              @if (template.nomeConta) {
                <span class="selecao-detalhe-conta" [title]="template.nomeConta">{{ template.nomeConta }}</span>
              }
            </div>

            <div class="selecao-previa-area">
              <ng-container [ngTemplateOutlet]="previa"></ng-container>
            </div>

            <ng-container [ngTemplateOutlet]="camposVariaveis"></ng-container>
          </div>

          <footer class="selecao-detalhe-acoes">
            <button type="button" class="selecao-btn-cancelar" [disabled]="enviando()" (click)="fechar.emit()">Cancelar</button>
            <ng-container [ngTemplateOutlet]="botaoEnviar"></ng-container>
          </footer>
        } @else if (!carregandoLista()) {
          <div class="selecao-detalhe-vazio">
            <img src="./assets/icones/redesign/modulos/chat/sessao-closed-not-msg.svg" alt="" />
            <span>Selecione um template para ver a prévia.</span>
          </div>
        } @else {
          <div class="selecao-detalhe-conteudo">
            <div class="skeleton selecao-skeleton-titulo" style="width: 45%"></div>
            <div class="skeleton selecao-skeleton-linha" style="width: 25%"></div>
            <div class="selecao-previa-area">
              <div class="skeleton selecao-skeleton-balao"></div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>
</div>

<ng-template #previa>
  @if (carregandoDetalhe()) {
    <div class="skeleton selecao-skeleton-balao"></div>
  } @else if (erroDetalhe()) {
    <div class="selecao-previa-erro">
      <span>Não foi possível carregar o template.</span>
      <button type="button" class="selecao-btn-texto" (click)="tentarNovamenteDetalhe()">Tentar novamente</button>
    </div>
  } @else if (detalhe()) {
    <div class="selecao-balao">
      @if (cabecalhoImagem()) {
        <img class="selecao-balao-imagem" [src]="cabecalhoImagem()" alt="" />
      }
      @if (cabecalhoTexto()) {
        <span class="chat-balao-cabecalho">{{ cabecalhoTexto() }}</span>
      }
      <span class="selecao-balao-texto">@for (segmento of segmentosPrevia(); track $index) {<span [class.selecao-balao-variavel]="segmento.variavel">{{ segmento.texto }}</span>}</span>
      @if (rodapeTexto()) {
        <span class="chat-balao-rodape-texto">{{ rodapeTexto() }}</span>
      }
      <span class="selecao-balao-hora">{{ horaAtual }}</span>
      @if (botoes().length) {
        <div class="chat-balao-botoes">
          @for (botao of botoes(); track $index) {
            <span class="chat-balao-botao">{{ botao }}</span>
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #camposVariaveis>
  @if (detalhe() && variaveis().length) {
    <div class="selecao-variaveis">
      @for (variavel of variaveisFixas(); track variavel.ordem) {
        <span class="selecao-variavel-legenda">Variável {{ rotuloVariavel(variavel.ordem) }} = {{ variavel.campoFixo }}</span>
      }
      @for (variavel of variaveisDigitadas(); track variavel.ordem) {
        <label class="selecao-variavel">
          <span class="selecao-variavel-rotulo">Variável {{ rotuloVariavel(variavel.ordem) }}</span>
          <input type="text" class="selecao-variavel-input" autocomplete="off"
                [placeholder]="variavel.exemplo ? 'Ex: ' + variavel.exemplo : 'Digite o valor'"
                [value]="variavel.valor" [disabled]="enviando()"
                (input)="alterarVariavel(variavel.ordem, $any($event.target).value)" />
        </label>
      }
    </div>
  }
</ng-template>

<ng-template #botaoEnviar>
  <button type="button" class="selecao-btn-enviar" [disabled]="!podeEnviar()" (click)="enviar()">
    @if (enviando()) {
      <span class="selecao-spinner"></span>
    } @else {
      <span>Selecionar e enviar</span>
      <img src="./assets/icones/redesign/modulos/chat/components-message/send-tempalte.svg" alt="" />
    }
  </button>
</ng-template>
